import colors from "./colors";

export default function createDoughnutChartData(data) {
  data.datasets[0].backgroundColor = data.datasets[0].data.map(
    (elem, i) => colors[i]
  );
  return data;
}
